export default __webpack_public_path__ + "static/media/Background_00093.cb836bee.png";